import { OrderedMap } from 'immutable';
import { SAVE_INSTANCE, UPDATE_INSTANCE, DELETE_INSTANCE } from '../constants/actions';

export function modelReducer(state = OrderedMap({}), action) {
    const typeToken = action.type.split('/');
    const type = typeToken.length > 1 ? typeToken[1] : action.type;
    switch (type) {
        case SAVE_INSTANCE:
            return state.set(action.key, action.instance);
        case UPDATE_INSTANCE:
            return state.update(action.key, action.instance);
        case DELETE_INSTANCE:
            return state.delete(action.key);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/modelReducer.ts